<script setup>
import ViewerIcon from './ViewerIcon.vue'

defineProps({
  open: Boolean,
  title: {
    type: String,
    default: '3D 空间'
  }
})

defineEmits(['close', 'download', 'share', 'actions'])
</script>

<template>
  <section class="sheet sheet--result" :class="{ 'is-open': open }" :aria-hidden="!open">
    <button class="sheet__handle" type="button" aria-label="收起生成结果" @click="$emit('close')">
      <ViewerIcon name="chevron-down" />
    </button>
    <div class="result-panel__header">
      <h2>{{ title }}</h2>
      <span class="result-panel__status"><i></i>成功</span>
    </div>
    <div class="result-panel__tabs">
      <button class="active" type="button">▧　全景生成</button><button type="button">◎　空间模型</button>
    </div>
    <div class="result-panel__actions">
      <button type="button" @click="$emit('download')">下载全景图</button>
      <button type="button" aria-label="分享模型" @click="$emit('share')"><ViewerIcon name="share" /></button>
      <button type="button" aria-label="更多" @click="$emit('actions')">•••</button>
    </div>
  </section>
</template>
